import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./DropdownMenu.module.css";

const DropdownMenu = ({ options, triggerIcon, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !triggerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleOpen = (event) => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + window.scrollY,
                left: rect.right + window.scrollX - 100,
            });
            event.stopPropagation();
            setIsOpen((prev) => !prev);
        }
    };


    return (
        <>
            <div ref={triggerRef} className={`${styles.trigger} ${className}`} onClick={(event) => handleOpen(event)}>
                <FontAwesomeIcon icon={triggerIcon} />
            </div>

            {isOpen &&
                createPortal(
                    <div ref={menuRef} className={styles.menu} style={{ top: position.top, left: position.left }} onClick={(event) => event.stopPropagation()}>
                        {options.map((option, index) => (
                            <div key={index} className={styles.menu_wrapper}>
                                <div
                                    key={index}
                                    className={`${styles.menuItem} ${option.className || ""}`}
                                    onClick={(event) => {
                                        setIsOpen(false);
                                        option.onClick(event);
                                    }}
                                >
                                    <FontAwesomeIcon icon={option.icon} />
                                    {option.name}
                                </div>
                            </div>
                        ))}
                    </div>,
                    document.body
                )}
        </>
    );
};

export default DropdownMenu;
